export default "__VITE_ASSET__b4o$dF9U__"